<template>
  <router-view></router-view>
</template>

<script setup></script>
<style>
body {
  background: #191919;
}
</style>
